<template>
  <div class="card mb-25 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Ajouter un produit</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="produitForm" @submit="addProduit" :keep-values="valuess" :validation-schema="produitSchema" :initial-values="{ seuilAppro: 0 }">
        <div class="row gx-1">
          <div class="col-md-12">
            <div class="row row gx-2">
              <!-- Image principale du produit -->
              <div class="col-md-2">
                <label class="d-block text-black fw-semibold mb-1">
                  Image Produit
                </label>
                <div class="upload-container">
                  <input type="file" ref="fileInput" @change="(event) => onFilePrinChange(event)"
                    accept="image/jpeg, image/png, image/jpg" hidden />
                  <!-- Carte d'aperçu (cliquable pour choisir une image) -->
                  <div class="preview-card" @click="triggerFileInput">
                    <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
                    <div v-else class="text-center">
                      <div>
                        <i class="icofont icofont-camera fs-1"></i>
                      </div>
                      Cliquez pour ajouter l'image principal du produit
                    </div>
                    <!-- Bouton de suppression sur l'image -->
                    <button type="button" v-if="imagePreview" class="delete-btn" @click.stop="removeImage"><i
                        class="icofont icofont-close"></i></button>
                  </div>
                </div>
              </div>

              <div class="col-md-10">
                <div class="row gx-1">
                  <div class="col-md-3">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Code du produit
                      </label>
                      <Field type="text" name="code" class="form-control shadow-none fs-md-15 text-black"
                        readonly="true" placeholder="Ce code est généré" />
                      <ErrorMessage name="code" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Référence usine du produit
                      </label>
                      <Field name="refProd" type="text" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Entrer la référence" />
                      <ErrorMessage name="refProd" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Famille du produit<span class="text-danger">*</span>
                      </label>
                      <Field name="famille" v-slot="{ field }">
                        <Multiselect :options="familleOptions" :searchable="true" track-by="label" label="label"
                          v-model="field.value" v-bind="field" @select="selectFamille(field.value)"
                          placeholder="Sélectionner la famille" />
                      </Field>
                      <ErrorMessage name="famille" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-sm-2 mb-md-2" ref="dropdownRef">
                      <label class="d-block text-black fw-semibold mb-1">
                        Nom du Produit<span class="text-danger">*</span>
                      </label>
                      <Field name="nomProd" type="text" v-model="prodName" @focus="showBox = true"
                        class="mb-2 form-control shadow-none fs-md-15 text-black"
                        placeholder="Entrer le nom du produit" />
                      <ul class="dropdown-menu show" v-if="produitOptions.length > 0 && showBox == true">
                        <li v-for="(produit, index) in produitOptions" :key="index">
                          <a class="dropdown-item" href="javascript:void(0);">{{ produit.codeProduit }} - {{
                            produit.nomProd }}</a>
                        </li>
                      </ul>
                      <ErrorMessage name="nomProd" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Unité de Stockage
                      </label>
                      <Field name="uniteStock" v-slot="{ field }" v-model="uniteStock">
                        <Multiselect :options="conditionnementOptions" :searchable="true" track-by="label" label="label"
                          v-model="field.value" v-bind="field" placeholder="Choisir l'unité de stockage" />
                      </Field>
                      <ErrorMessage name="uniteStock" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Unité de gestion
                      </label>
                      <Field name="uniteGestion" v-slot="{ field }" v-model="uniteGestion">
                        <Multiselect :options="conditionnementgOptions" :searchable="true" track-by="label"
                          label="label" v-model="field.value" v-bind="field" @select="seletUniteGestion(field.value)"
                          placeholder="Choisir l'unité de gestion" />
                      </Field>
                      <ErrorMessage name="uniteGestion" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-3 mb-sm-3 mb-md-3">
                      <label class="d-block text-black fw-semibold mb-1">
                        Seuil d'approvisionnement
                      </label>
                      <div class="input-group">
                        <Field name="seuilAppro" type="number" min="0"
                          class="form-control shadow-none fs-md-15 text-black" placeholder="Ex : 10" />
                        <span class="input-group-text">{{ uniteGestion != null ? uniteGestion.split("|")[2] : '' }}</span>
                      </div>
                      <ErrorMessage name="seuilAppro" class="text-danger" />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-3 mb-sm-3 mb-md-3">
              <label class="d-block text-black fw-semibold mb-1">
                Description du produit
              </label>
              <Field name="descProd" as="textarea" placeholder="Entrer la description" v-slot="{ field }"
                class="form-control shadow-none rounded-0 text-black">
                <textarea class="form-control shadow-none rounded-0 text-black" v-model="field.value"></textarea>
              </Field>
              <ErrorMessage name="descProd" class="text-danger" />
            </div>
          </div>
          <div class="col-md-3" v-for="(champsLibre, index) in chamsdescritifs" :key="index">
            <div class="form-group mb-3 mb-sm-3 mb-md-3">
              <label class="d-block text-black fw-semibold mb-1">
                {{ champsLibre.libelleChamp }} <span class="text-danger" v-if="champsLibre.estObligatoire == 1">*</span>
              </label>
              <div v-if="champsLibre.typeChamp == 'boolean'">
                <label>
                  <input type="radio" v-model="champsLibre.valeur"
                    :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-check shadow-none fs-md-15 text-black is-invalid ' : 'form-control shadow-none fs-md-15 text-black '"
                    name="status" value="1" checked> Oui
                </label>
                <label>
                  <input type="radio" v-model="champsLibre.valeur"
                    :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-check shadow-none fs-md-15 text-black is-invalid ' : 'form-control shadow-none fs-md-15 text-black '"
                    name="status" value="0"> Non
                </label>
                <div v-if="valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1"
                  class="text-danger">
                  {{ champsLibre.libelleChamp }} est obligatoire.
                </div>
              </div>
              <div v-else-if="champsLibre.typeChamp == 'name'" class="input-group">
                <select v-if="champsLibre.modeSaisie == 'keywordValueList'"
                  :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-select shadow-none fs-md-15 text-black is-invalid ' : 'form-select shadow-none fs-md-15 text-black '"
                  v-model="champsLibre.valeur" :name="champsLibre.nomChamp">
                  <option value="" disabled>Sélectionner</option>
                  <option v-for="(option, index) in champsLibre.valeurPossible" :key="index" :value="option.value">
                    {{ option.libelle }}
                  </option>
                </select>
                <select v-if="champsLibre.modeSaisie == 'keywordKeyValueList'"
                  :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-select shadow-none fs-md-15 text-black is-invalid ' : 'form-select shadow-none fs-md-15 text-black '"
                  v-model="champsLibre.valeur" :name="champsLibre.nomChamp">
                  <option value="" disabled>Sélectionner</option>
                  <option v-for="(option, index) in champsLibre.valeurPossible" :key="index" :value="option.valeur">
                    {{ option.libelle }}
                  </option>
                </select>
              </div>
              <div v-else class="input-group">
                <input
                  :class="(valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-control shadow-none fs-md-15 text-black is-invalid ' : 'form-control shadow-none fs-md-15 text-black '"
                  v-model="champsLibre.valeur" :name="champsLibre.nomChamp" :type="champsLibre.typeChamp" />
              </div>
              <div v-if="valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1" class="text-danger">
                {{ champsLibre.libelleChamp }} est obligatoire.
              </div>
            </div>
          </div>

          <!-- Conditionnements (l'onglet "Image" a été supprimé) -->
          <div class="col-md-12 mb-md-25">
            <div class="row">
              <div class="border border-primary mb-1">
                <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                  style="background-color: #0a59a4">
                  <div class="col-md-7">
                    <h3 class="fs-4 text-white">
                      Conditionnement(s) du produit
                    </h3>
                  </div>
                  <div class="col-md-5">
                    <div class="d-flex float-end">
                      <button
                        class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                        type="button" :class="{ 'cursor-not-allowed': isDisable }" :disabled="isDisable"
                        @click="addRowConditionnement()">
                        <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                        Ajouter un conditionnement
                      </button>
                      <router-link to="/liste-mouvements"></router-link>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="row gx-1 ">
                    <div class="col-md-2">
                      <label class="d-block text-black fw-semibold">
                        Conditionnement
                        <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label class="d-block text-black fw-semibold mb-1">
                        Quantité <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label class="d-block text-black fw-semibold mb-1">
                        Prix Min <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label class="d-block text-black fw-semibold mb-1">
                        PrixDeVente <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label class="d-block text-black fw-semibold mb-1">
                        Prix Max <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label class="d-block text-black fw-semibold mb-1">
                        Action
                      </label>
                    </div>
                  </div>
                  <hr class="mt-0" />
                  <div class="row gx-1" v-for="(conditionnement, index) in conditionnements" :key="index">
                    <div class="col-md-2 mb-3">
                      <div class="">
                        <input v-if="index == 0" type="text" readonly :value="uniteGestion?.split('|')[2]"
                          class="form-control shadow-none fs-md-15 text-black" />
                        <Multiselect v-else :options="conditionnementOptions" :searchable="true" track-by="label"
                          label="label" v-model="conditionnement.conditionnement" placeholder="Sélectionner"
                          @select="selectConditionnement(conditionnement.conditionnement, conditionnement)" />
                        <div class="invalid-feedback" v-if="valideteRowProduit(conditionnement.conditionnement)">
                          Le conditionnement est obligatoire.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2 mb-3">
                      <div class="form-group mb-2 ">
                        <input v-if="index == 0" type="text" readonly v-model="conditionnement.quantite"
                          class="form-control shadow-none fs-md-15 text-black" />
                        <div class="input-group" v-else>
                          <input type="number" v-model="conditionnement.quantite" :class="valideteRowProduit(conditionnement.quantite)
                            ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                            : 'form-control shadow-none fs-md-15 text-black '" placeholder="Entrer la quantité"
                            aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                          <span class="input-group-text" id="inputGroup-sizing-default">{{ uniteGestion != null
                            ? (uniteGestion?.split("|")[2]) : 'UM' }}</span>
                        </div>
                        <div v-if="valideteRowProduit(conditionnement.quantite)" class="invalid-feedback">
                          La quantité est obligatoire.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2 mb-3">
                      <div class="form-group mb-2 ">
                        <input v-if="index == 0" type="text" v-model="conditionnement.prixMin"
                          class="form-control shadow-none fs-md-15 text-black" />
                        <div class="input-group" v-else>
                          <input type="number" v-model="conditionnement.prixMin"
                            :class="isPrixMinInvalid(conditionnement)
                              ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                              : 'form-control shadow-none fs-md-15 text-black'"
                            placeholder="Entrer le prix minimal" aria-label="Saisir le prix minimal"
                            aria-describedby="inputGroup-sizing-sm" />
                        </div>
                        <div v-if="isPrixMinInvalid(conditionnement)" class="invalid-feedback">
                          Le prix minimal doit être inférieur ou égal au prix de vente.
                        </div>
                        <div v-if="valideteRowProduit(conditionnement.prixMin)" class="invalid-feedback">
                          Le prix minimal est obligatoire.
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2 mb-3">
                      <div class="form-group mb-2 ">
                        <input v-if="index == 0" type="text" v-model="conditionnement.prixVente"
                          class="form-control shadow-none fs-md-15 text-black" />
                        <div class="input-group" v-else>
                          <input type="number" v-model="conditionnement.prixVente" :class="valideteRowProduit(conditionnement.prixVente)
                            ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                            : 'form-control shadow-none fs-md-15 text-black '" placeholder="Entrer le prix de vente"
                            aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>
                        <div v-if="valideteRowProduit(conditionnement.prixVente)" class="invalid-feedback">
                          Le prix de vente est obligatoire.
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2 mb-3">
                      <div class="form-group mb-2 ">
                        <input v-if="index == 0" type="text" v-model="conditionnement.prixMax"
                          class="form-control shadow-none fs-md-15 text-black" />
                        <div class="input-group" v-else>
                          <input type="number" v-model="conditionnement.prixMax" :class="isPrixMaxInvalid(conditionnement)
                            ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                            : 'form-control shadow-none fs-md-15 text-black '" placeholder="Entrer le prix maximal"
                            aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                        </div>
                        <div v-if="isPrixMaxInvalid(conditionnement)" class="invalid-feedback">
                          Le prix Max doit être supérieur ou égal au prix de vente
                        </div>
                        <div v-if="valideteRowProduit(conditionnement.prixMax)" class="invalid-feedback">
                          Le prix maximal est obligatoire.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2 mb-3" v-if="index > 0">
                      <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                        @click="removeRowConditionnement(index)">
                        <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button class="btn btn-success me-3" type="submit" :disabled="(isDisable || isDisableCha) ? true : false"
                :class="(!isDisable || !isDisableCha) ? { 'cursor-not-allowed': false } : { 'cursor-not-allowed': true }">
                Ajouter un produit
              </button>
              <router-link to="/produits/liste-produits" class="btn btn-danger"><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive, onBeforeUnmount } from "vue";
import { Form, Field, ErrorMessage, useFieldArray } from "vee-validate";
import { error, success } from "@/utils/utils";
import { useRouter, useRoute } from "vue-router";

import ApiService from "@/services/ApiService";
import { Produit } from "@/models/Produit";
import * as Yup from "yup";
import axios from "axios";
import Multiselect from "@vueform/multiselect";
import { ChampsLibre } from "@/models/ChampsLibre";


export default defineComponent({
  name: "AddProduit",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: () => {
    const produitForm = ref<Produit | null>(null);
    const router = useRouter();
    const route = useRoute();
    const familleOptions = ref([]);
    const famille = ref();
    const prodName = ref("");
    const isDisableCha = ref(false);
    const conditionnementOptions = ref([]);
    const conditionnementgOptions = ref([]);
    const produitOptions = ref([]);
    const prixProd = ref();
    const produitsss: any = ref(null);
    const valuess = ref();
    const showBox = ref(false);
    const chamsdescritifs = reactive<Array<ChampsLibre>>([]);
    const uniteStock = ref(null);

    // Image principale du produit
    const fileInput = ref<HTMLInputElement | null>(null);
    const imagePreview = ref<string | null>(null);
    const imageFile = ref<File | null>(null);

    const triggerFileInput = () => {
      fileInput.value?.click();
    };

    const onFilePrinChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          imagePreview.value = e.target.result as string;
        };
        reader.readAsDataURL(file);
      }
    };

    const removeImage = () => {
      imagePreview.value = null;
      imageFile.value = null;
      // permet de re-sélectionner le même fichier après suppression
      if (fileInput.value) fileInput.value.value = "";
    };

    watch(prodName, (newValue) => {
      if (newValue && newValue.length >= 3) {
        fetchProduis(newValue);
      } else {
        produitOptions.value = [];
      }
    });

    const montantTotal = ref(0);
    const isDisable = ref(true);
    const conditionnements = reactive([]);

    const addRowConditionnement = () => {
      conditionnements.push({
        conditionnement: "",
        quantite: 0,
        prixMin: null,
        prixVente: null,
        prixMax: null,
        conditionnement2: ""
      });
    };

    const dropdownRef = ref(null);

    function handleClickOutside(event) {
      if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        showBox.value = false;
      }
    }

    function getProduit(id: number) {
      ApiService.get("/produits/" + id.toString())
        .then(({ data }) => {
          console.log(data.data, "datadatadatadatadatadatadatadata");
          for (const key in data.data) {
            produitForm.value?.setFieldValue(key, (typeof data.data[key] === 'object' && data.data[key] !== null) ? data.data[key].id : data.data[key]);
          }
          produitForm.value?.setFieldValue("famille", data.data["famille"].id)
          console.log("famille ===> ", data.data["famille"])
          famille.value = parseInt(data.data["famille"].id);
          produitForm.value?.setFieldValue("uniteStock", data.data["uniteStock"].id + "|" + data.data["uniteStock"].valeur + "|" + data.data["uniteStock"].libelle);
          produitForm.value?.setFieldValue("uniteGestion", data.data["uniteGestion"].id + "|" + data.data["uniteGestion"].valeur + "|" + data.data["uniteGestion"].libelle);
          produitForm.value?.setFieldValue("codeProduit", "");
          produitForm.value?.setFieldValue("id", null);
          produitForm.value?.setFieldValue("imagePrincipal", null);
          delete produitForm.value?.id;
          if (data.data["produitchampslibres"] != null) {
            data.data["produitchampslibres"].forEach(element => {
              chamsdescritifs.push({
                id: parseInt(element.champslibre.id),
                libelleChamp: element.champslibre.libelleChamp,
                estObligatoire: element.champslibre.estObligatoire,
                typeChamp: element.champslibre.typeChamp,
                nomChamp: element.champslibre.nomChamp,
                valeur: element.valeur,
                idProChamp: null,
              });
            });
          }

          if (data.data["produitconditionnements"] != null) {
            data.data["produitconditionnements"].forEach(element => {
              conditionnements.push({
                conditionnement: element.conditionnement.id + "|" + element.conditionnement.valeur + "|" + element.conditionnement.libelle,
                quantite: element.qteCond,
                conditionnement2: element.conditionnement2.id + "|" + element.conditionnement2.valeur + "|" + element.conditionnement2.libelle,
              });
            });
          }

          console.log("FOOROROROROROMMM ===> ", famille.value)
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    const removeRowConditionnement = (index) => {
      if (conditionnements.length > 1) conditionnements.splice(index, 1);
    };

    const valideteRowProduit = (e) => {
      if (e == "" || e == 0 || e == "0" || e == null || e < 0) {
        return true;
      } else {
        return false;
      }
    };

    const isPrixMinInvalid = (conditionnement) => {
      if (conditionnement.prixMin != null && conditionnement.prixVente != null) {
        return conditionnement.prixMin > conditionnement.prixVente;
      }
      return false;
    };

    const isPrixMaxInvalid = (conditionnement) => {
      if (conditionnement.prixMax != null && conditionnement.prixVente != null) {
        return conditionnement.prixMax < conditionnement.prixVente;
      }
      return false;
    };

    const selectFamille = (value) => {
      console.log(value, "valuevaluevaluevalue");
      if (parseInt(value) > 0) {
        fetchAllChamps(parseInt(value));
      } else {
        chamsdescritifs.length = 0;
      }
    }

    watch(conditionnements, (newValue, oldValue) => {
      let isInvalid = false;
      Object.keys(newValue).forEach(function (key) {
        if (
          valideteRowProduit(newValue[key].conditionnement) ||
          valideteRowProduit(newValue[key].quantite) ||
          valideteRowProduit(newValue[key].prixVente) ||
          valideteRowProduit(newValue[key].prixMin) ||
          valideteRowProduit(newValue[key].prixMax)
        ) {
          isInvalid = true;
        } else if (
          newValue[key].prixMin != null &&
          newValue[key].prixVente != null &&
          parseFloat(newValue[key].prixMin) > parseFloat(newValue[key].prixVente)
        ) {
          isInvalid = true;
        } else if (
          newValue[key].prixMax != null &&
          newValue[key].prixVente != null &&
          parseFloat(newValue[key].prixMax) < parseFloat(newValue[key].prixVente)
        ) {
          isInvalid = true;
        }
      });
      isDisable.value = isInvalid;
    });

    watch(chamsdescritifs, (newValue, oldValue) => {
      const newValueLast = newValue.filter(order => order.estObligatoire == 1);
      console.log(newValueLast, "newValueLastnewValueLast");
      Object.keys(newValueLast).forEach(function (key) {
        if (newValueLast[key].valeur == "" || newValue[key].valeur == 0) {
          if (newValueLast[key].estObligatoire == 1) {
            isDisableCha.value = true;
            console.log(isDisableCha.value, "isDisableCha.value true");
          }
        } else {
          isDisableCha.value = false;
          console.log(isDisableCha.value, "isDisableCha.value false");
        }
      });
    });

    const { remove, push, fields, update } = useFieldArray("conditionnements");

    const fetchConditionnements = async () => {
      try {
        const response = await axios.get("/conditionnements");
        const conditionnementsData = response.data.data;
        produitsss.value = conditionnementsData;
        conditionnementOptions.value = conditionnementsData.map((conditionnement) => ({
          value: conditionnement.id + "|" + conditionnement.valeur + "|" + conditionnement.libelle,
          label: `${conditionnement.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchConditionnementugs = async () => {
      try {
        const response = await axios.get("/conditionnementugs");
        const conditionnementgData = response.data.data;
        produitsss.value = conditionnementgData;
        conditionnementgOptions.value = conditionnementgData.map((conditionnement) => ({
          value: conditionnement.id + "|" + conditionnement.valeur + "|" + conditionnement.libelle,
          label: `${conditionnement.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchAllChamps = async (id) => {
      try {
        const response = await axios.get("/champsdescritif/famille/" + id);
        console.log(response.data, "response.dataresponse.dataresponse.data");
        chamsdescritifs.length = 0;
        response.data.data.forEach(element => {
          chamsdescritifs.push(element.champslibre);
        });
        console.log(chamsdescritifs, "chamsdescritifs.valuechamsdescritifs.value");
      } catch (error) {
        //
      }
    };

    const fetchProduis = async (newValue) => {
      try {
        const response = await ApiService.get(`produits/recherche?keyword=${newValue}&type=0`);
        console.log(response, "responseresponseresponseresponse");
        produitOptions.value = response.data.data;
      } catch (error) {
        //
      }
    };

    const selectConditionnement = async (value: any, conditionnement: any) => {
      console.log("Element", value);
      console.log("Objet", conditionnement.quantite);
      conditionnement.quantite = value.split("|")[1];
    };

    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const addProduit = async (values, { resetForm }) => {
      console.log('Valeurs du formulaire :', values);
      values.conditionnements = conditionnements.map(conditionnement => ({
        conditionnement: conditionnement.conditionnement.split("|")[0],
        qteCond: conditionnement.quantite,
        prixMin: conditionnement.prixMin,
        prixVente: conditionnement.prixVente,
        prixMax: conditionnement.prixMax,
        conditionnement2: uniteGestion.value.split("|")[0],
      }));
      values["uniteGestion"] = uniteGestion.value.split("|")[0]
      values["uniteStock"] = uniteStock.value.split("|")[0]
      values.seuilAppro = Number(values.seuilAppro) || 0;

      // Image principale
      if (imageFile.value) {
        values["imagePrincipal"] = imageFile.value;
      }

      values.champsdescritifs = chamsdescritifs.map(champsdescritif => ({
        champslibre: champsdescritif.id,
        valeur: champsdescritif.valeur,
      }));
      console.log('Les champs descriptifs ===> ', values);
      // retirer urlImage du values
      delete values.urlImage;

      console.log('Mon FORMIULAIRE', values);

      ApiService.postWithFile("/produits", values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeProduit" });
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const fetchFamille = async () => {
      try {
        const response = await ApiService.get("all/all/familles");
        const familleData = response.data.data.data;
        console.log(familleData, "familleData");
        familleOptions.value = familleData.map((famille) => ({
          value: famille.id,
          label: `${famille.codeFamille} - ${famille.libelleFamille} ${famille.famille ? '(' + famille.famille.libelleFamille + ')' : ""}`,
        }));
      } catch (error) {
        //
      }
    };

    const produitSchema = Yup.object().shape({
      refProd: Yup.string().notRequired(),
      nomProd: Yup.string().required("Le nom est obligatoire"),
      imagePrincipal: Yup.string().notRequired(),
      famille: Yup.string().required("La famille est obligatoire"),
      uniteGestion: Yup.string().notRequired(),
      uniteStock: Yup.string().required("L'unité de stockage est obligatoire"),
      descProd: Yup.string().notRequired(),
      seuilAppro: Yup.number()
                    .transform((value, original) => (original === "" ? 0 : value))
                    .typeError("Le seuil doit être un nombre")
                    .min(0, "Le seuil ne peut pas être négatif")
                    .notRequired(),
    });

    const seletUniteGestion = (valeur) => {
      uniteGestion.value = valeur;
      conditionnements.length = 0;
      conditionnements.push({
        conditionnement: uniteGestion.value.split("|")[0],
        quantite: uniteGestion.value.split("|")[1],
        prixMin: null,
        prixVente: null,
        prixMax: null,
        conditionnement2: ""
      });
    }

    const uniteGestion = ref(null);
    onMounted(async () => {
      document.addEventListener('click', handleClickOutside);
      await fetchFamille();
      await fetchConditionnements();
      await fetchConditionnementugs();
      if (route.params.id) {
        console.log("ID from route params:", route.params.id);
        await getProduit(parseInt(route.params.id as string));
      }
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return {
      seletUniteGestion,
      produitOptions,
      uniteGestion,
      prodName,
      addProduit,
      produitForm,
      familleOptions,
      conditionnements,
      conditionnementgOptions,
      removeRowConditionnement,
      addRowConditionnement,
      valideteRowProduit,
      isPrixMaxInvalid,
      isPrixMinInvalid,
      montantTotal,
      valuess,
      conditionnementOptions,
      prixProd,
      selectConditionnement,
      isDisable,
      getCurrentDate,
      isDisableCha,
      chamsdescritifs,
      selectFamille,
      produitSchema,
      uniteStock,
      showBox,
      dropdownRef,
      // image principale
      triggerFileInput,
      onFilePrinChange,
      removeImage,
      imagePreview,
      imageFile,
      fileInput,
    };
  },
});
</script>

<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.preview-card {
  width: 100%;
  height: 200px;
  border: 2px dashed #4caf50;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  background: #f8f8f8;
  position: relative;
}

.preview-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: red;
  color: white;
  border: none;
  padding: 5px 8px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
}

.delete-btn:hover {
  background: darkred;
}
</style>